import { Locale } from 'modules/i18n';

export const requestsChartTranslation = {
  [Locale.en]: {
    title: 'Total requests',
  },
};
